import demandsReducer from './demandsReducer';

export default demandsReducer;
